"use client";

import React from "react";
import { Inbox, RefreshCw } from "lucide-react";

import { Button } from "@/components/ui/button";

interface SupportInboxHeaderProps {
  threadCount: number;
  groupEmail: string | null;
  isRefreshing: boolean;
  onRefresh: () => void;
}

/** Title row for the Support Inbox tab: count, group address, refresh. */
export function SupportInboxHeader({
  threadCount,
  groupEmail,
  isRefreshing,
  onRefresh,
}: SupportInboxHeaderProps) {
  return (
    <div className="flex items-center justify-between gap-2">
      <div className="flex items-center gap-2 min-w-0">
        <Inbox className="w-5 h-5 text-gray-600 dark:text-gray-400 shrink-0" />
        <h3 className="text-base md:text-lg font-semibold text-card-foreground truncate">
          Support Inbox
        </h3>
        {threadCount > 0 && (
          <span className="rounded-full bg-muted px-2 py-0.5 text-[11px] font-medium text-muted-foreground shrink-0">
            {threadCount}
          </span>
        )}
        {groupEmail && (
          <span className="hidden sm:inline text-xs text-muted-foreground font-mono truncate">
            {groupEmail}
          </span>
        )}
      </div>
      <Button
        type="button"
        variant="ghost"
        size="sm"
        onClick={onRefresh}
        className="text-muted-foreground shrink-0"
        title="Refresh"
      >
        <RefreshCw className={`w-4 h-4 ${isRefreshing ? "animate-spin" : ""}`} />
      </Button>
    </div>
  );
}
